import React, { useEffect } from "react";

import {
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useSetRecoilState,
} from "recoil";
import {
  aspectListState,
  asyncGetAspectList,
  asyncSearchAspect,
  currentAspectSelected,
  selectedAspect,
} from "lib/store/dashboard";
import { aspectMaxPageState, aspectPageState } from "lib/store/sentiment";

import { Box } from "@atsent/components";

import { HeaderNSidebar } from "components/template/HeaderNSidebar";
import { DashboardDateToolbar } from "components/atom/DashboardDateToolbar";
import { ThreadList } from "components/atom/TreadList";
import { SentimentSummary } from "components/atom/SentimentSummary";

import "./AspectsPage.scss";

export type AspectsPageProps = {
  cx?: string;
};

export const AspectsPage: React.FC<AspectsPageProps> = ({ cx = "" }) => {
  const setPage = useSetRecoilState(aspectPageState);
  const setTotalPage = useSetRecoilState(aspectMaxPageState);
  const asyncLoadableState = useRecoilStateLoadable(
    asyncSearchAspect({ page: 1, aspect: "ㅁㄴㅇ" })
  );
  const aspectList = useRecoilValueLoadable(asyncGetAspectList);
  const setAspect = useSetRecoilState(selectedAspect);
  const list = useRecoilValue(aspectListState);
  const currentState = useRecoilState(currentAspectSelected);
  useEffect(() => {
    if (
      aspectList.state === "hasValue" &&
      !!aspectList.contents &&
      aspectList.contents.length > 0
    ) {
      const { aspect } = aspectList.contents[0];
      setAspect(aspect);
    }
  }, [aspectList, setAspect]);

  return (
    <HeaderNSidebar cx={`AspectsPage ${cx}`}>
      <DashboardDateToolbar cx={"SelectDate align-center"} />
      <Box cx={"threadBox"}>
        <SentimentSummary />
        <ThreadList
          currentState={currentState}
          setPage={setPage}
          setTotalPage={setTotalPage}
          asyncLoadableState={asyncLoadableState}
          list={list}
          expend
        />
      </Box>
    </HeaderNSidebar>
  );
};
